import { render, staticRenderFns } from "./StratificationCard.vue?vue&type=template&id=113ef3eb&scoped=true"
import script from "./StratificationCard.vue?vue&type=script&lang=js"
export * from "./StratificationCard.vue?vue&type=script&lang=js"
import style0 from "./StratificationCard.vue?vue&type=style&index=0&id=113ef3eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113ef3eb",
  null
  
)

export default component.exports